import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowDown = (props) => (
  <Icon viewBox="0 0 360 227.3" {...props}>
    <g>
      <path fill="currentColor" d="M358 44.7L313.7 1.6 183.4 135.8 45.3 1.6 2.3 46l178.4 171.4 4.9 4.8z" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowDown;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowDown.js